import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function HopitalInscription() {
  const [wilayas, setWilayas] = useState([]);
  const [form, setForm] = useState({ name: "", wilaya_code: "", address: "", phone: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/wilayas`).then((r) => {
      const d = r.data;
      let list = [];
      if (Array.isArray(d)) list = d.map((x) => (typeof x === "string" ? { code: x, name: x } : { code: x.code || x.wilaya_code || x.id, name: x.name_fr || x.name || x.nom || x.label || x.name_ar || x.code }));
      else if (d && typeof d === "object") list = Object.entries(d).map(([code, name]) => ({ code, name }));
      setWilayas(list);
    }).catch(() => {});
  }, []);

  const submit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.password || !form.wilaya_code || !form.address.trim() || !form.phone.trim()) {
      setError("Tous les champs sont obligatoires."); return;
    }
    setLoading(true); setError("");
    try {
      await axios.post(`${API_URL}/api/sih/establishments/register`, form);
      setDone(true);
    } catch (e) {
      setError(e.response?.data?.detail || "Une erreur est survenue. Reessayez.");
    } finally { setLoading(false); }
  };

  const iS = { width: "100%", padding: "11px 14px", border: "1px solid #CBD5E1", borderRadius: 8, fontSize: 14, boxSizing: "border-box", background: "#fff" };
  const lab = { fontSize: 13, color: "#475569", marginBottom: 6, display: "block", fontWeight: 500 };

  return (
    <div style={{ minHeight: "100vh", background: "#F1F5F9", display: "flex", justifyContent: "center", alignItems: "flex-start", padding: "40px 20px" }}>
      <div style={{ width: "100%", maxWidth: 560 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: "#0F172A", margin: 0 }}>Inscrire un hopital</h1>
          <p style={{ fontSize: 14, color: "#64748B", marginTop: 8 }}>Creez l'espace de gestion de votre etablissement sur Tabbibak.</p>
        </div>

        {done ? (
          <div style={{ background: "#fff", border: "1px solid #B7E0C2", borderRadius: 12, padding: 28, textAlign: "center" }}>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#1E7A3D", marginBottom: 10 }}>Demande enregistree</div>
            <p style={{ fontSize: 14, color: "#475569", lineHeight: 1.6 }}>
              Un email de verification vient de vous etre envoye. Confirmez votre adresse,
              puis votre compte sera <b>active apres validation par notre equipe</b>.
              Vous pourrez ensuite vous connecter et acceder a votre espace hopital.
            </p>
            <Link to="/login" style={{ display: "inline-block", marginTop: 16, fontSize: 14, color: "#185FA5", textDecoration: "none" }}>Aller a la connexion</Link>
          </div>
        ) : (
          <div style={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, padding: 28 }}>
            {error && <div style={{ background: "#FCEBEB", border: "1px solid #F7C1C1", color: "#A32D2D", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 13 }}>{error}</div>}

            <div style={{ fontSize: 12, fontWeight: 700, color: "#185FA5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 }}>Etablissement</div>
            <div style={{ marginBottom: 14 }}><label style={lab}>Nom de l'hopital *</label><input style={iS} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
              <div><label style={lab}>Wilaya *</label><select style={iS} value={form.wilaya_code} onChange={(e) => setForm({ ...form, wilaya_code: e.target.value })}><option value="">...</option>{wilayas.map((w) => <option key={w.code} value={w.code}>{w.code} - {w.name}</option>)}</select></div>
              <div><label style={lab}>Telephone *</label><input style={iS} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            </div>
            <div style={{ marginBottom: 18 }}><label style={lab}>Adresse *</label><input style={iS} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>

            <div style={{ fontSize: 12, fontWeight: 700, color: "#185FA5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 }}>Compte responsable</div>
            <div style={{ marginBottom: 14 }}><label style={lab}>Email *</label><input type="email" style={iS} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div style={{ marginBottom: 6 }}><label style={lab}>Mot de passe *</label><input type="password" style={iS} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
            <p style={{ fontSize: 12, color: "#94A3B8", margin: "0 0 18px" }}>Au moins 8 caracteres, avec majuscule, minuscule et chiffre.</p>

            <button onClick={submit} disabled={loading} style={{ width: "100%", padding: "12px", background: loading ? "#94A3B8" : "#185FA5", color: "#fff", border: "none", borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer" }}>{loading ? "Envoi..." : "Envoyer la demande"}</button>

            <p style={{ fontSize: 13, color: "#64748B", textAlign: "center", marginTop: 16 }}>Deja un compte ? <Link to="/login" style={{ color: "#185FA5", textDecoration: "none" }}>Se connecter</Link></p>
          </div>
        )}
      </div>
    </div>
  );
}
